module.exports = __webpack_public_path__ + "media/images/front/new2-7029b2fbf8e5c958cc29ae45e1fdffd3.png";